import React, { useEffect, useState, useRef } from "react";
import { useLogout } from "../../hooks/useLogout";
import { Button, Typography, Menu, MenuItem } from "@mui/material";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { AccountCircle, ExpandMore, SettingsOutlined, Logout, DisplaySettingsRounded, ArticleRounded } from "@mui/icons-material";
import { useAuthContext } from "../../hooks/useContext/useAuthContext";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useTranslation } from "../../hooks/useTranslation";

export default function DashboardNavButton({ email, theme }) {
  const { logout } = useLogout();
  const buttonRef = useRef(null);
  const [buttonWidth, setButtonWidth] = useState(null);
  const location = useLocation();
  const { user } = useAuthContext();
  const { t } = useTranslation();


  const isActiveRoute = (path) => {
    return location.pathname === path;
  };

  const handleLogOut = () => {
    logout();
  };

  useEffect(() => {
    if (buttonRef.current && window.innerWidth > 600) {
      setButtonWidth(buttonRef.current.offsetWidth);
    }
  }, []);

 const menuItemStyle = {
    color: theme.palette.common.grey,
    borderRadius: "10px",
    backgroundColor: theme.palette.common.white,
    padding: "20px",
  }

  return user ? (
    <PopupState variant="popover" popupId="demo-popup-menu">
      {(popupState) => (
        <>
          <Button
            ref={buttonRef}
            variant="contained"
            {...bindTrigger(popupState)}
            sx={{
              boxShadow: "none",
              padding: "20px",
              backgroundColor: theme.palette.common.white,
              display: "flex",
              height: "64px",
              "&:focus": { color: theme.palette.common.white },
              "&:hover": {
                backgroundColor: theme.palette.common.white,
                boxShadow: "none",
              },
            }}
          >
            <AccountCircle
              sx={{
                paddingRight: {
                  xs: "2px",
                  sm: "20px",
                  md: "20px",
                  lg: "20px",
                  xl: "20px",
                },
                color: theme.palette.common.offGrey,
                "&:focus": { color: theme.palette.common.white },
                "&:hover": { backgroundColor: theme.palette.common.white },
                fontSize: "40px",
              }}
            />

            <Typography
              variant="p"
              component="p"
              sx={{
                paddingRight: "80px",
                textTransform: "lowercase",
                display: {
                  xs: "none",
                  sm: "block",
                  md: "block",
                  lg: "block",
                  xl: "block",
                },
              }}
            >
              {email}
            </Typography>

            <ExpandMore
              sx={{
                color: theme.palette.common.grey,
                "&:focus": { color: theme.palette.common.white },
                "&:hover": { backgroundColor: theme.palette.common.white },
              }}
            />
          </Button>

          <Menu
            {...bindMenu(popupState)}
            slotProps={{
              paper: {
                style: {
                  width: buttonWidth,
                  border: `1px solid ${theme.palette.component.borderColor}`,
                  borderRadius: "10px",
                },
              },
            }}
          >
{/* Dashboard */}
            <MenuItem onClick={popupState.close} component={RouterLink} to="/dashboard"
              sx={{
                ...menuItemStyle,
                backgroundColor: isActiveRoute("/dashboard") ? theme.palette.primary.main : theme.palette.common.white,
                "&:hover": {
                  ".MuiTypography-root": {
                    color: isActiveRoute("/dashboard") ? theme.palette.common.grey : theme.palette.primary.main
                  },
                  ".MuiSvgIcon-root": {
                    color: isActiveRoute("/dashboard") ? theme.palette.common.grey : theme.palette.primary.main
                  }
                },
              }}
            >
              <AccountCircle sx={{ paddingRight: "20px", color: isActiveRoute("/dashboard") ? theme.palette.common.white : theme.palette.common.grey, fontSize: "40px" }} />
              <Typography variant="p" component="p" noWrap sx={{ color: isActiveRoute("/dashboard") ? theme.palette.common.white : theme.palette.common.grey }}>
                {/* {email} */} {t('dashboard')}
              </Typography>
            </MenuItem>
{/* Menu Items */}
            <MenuItem 
              onClick={popupState.close} 
              component={RouterLink} 
              to="/menu_items"
              sx={{
                ...menuItemStyle,
                backgroundColor: isActiveRoute("/menu_items") ? theme.palette.primary.main : theme.palette.common.white,
                "&:hover": {
                  ".MuiTypography-root": {
                    color: isActiveRoute("/menu_items") ? theme.palette.common.grey : theme.palette.primary.main
                  },
                  ".MuiSvgIcon-root": {
                    color: isActiveRoute("/menu_items") ? theme.palette.common.grey : theme.palette.primary.main
                  }
                },
              }}
            >
              <DisplaySettingsRounded
                sx={{
                  paddingRight: "20px",
                  color: isActiveRoute("/menu_items") ? theme.palette.common.white : theme.palette.common.grey,
                  fontSize: "40px"
                }}
              />
              <Typography variant="p" component="p" noWrap sx={{ color: isActiveRoute("/menu_items") ? theme.palette.common.white : theme.palette.common.grey}}>
                {t('menuItems')}
              </Typography>
            </MenuItem>
{/* All Orders */}
            <MenuItem 
              onClick={popupState.close} 
              component={RouterLink} 
              to="/all_orders"
              sx={{
                ...menuItemStyle,
                backgroundColor: isActiveRoute("/all_orders") ? theme.palette.primary.main : theme.palette.common.white,
                "&:hover": {
                  ".MuiTypography-root": {
                    color: isActiveRoute("/all_orders") ? theme.palette.common.grey : theme.palette.primary.main
                  },
                  ".MuiSvgIcon-root": {
                    color: isActiveRoute("/all_orders") ? theme.palette.common.grey : theme.palette.primary.main
                  }
                },
              }}
            >
              <ArticleRounded
                sx={{
                  paddingRight: "20px",
                  color: isActiveRoute("/all_orders") ? theme.palette.common.white : theme.palette.common.grey,
                  fontSize: "40px"
                }}
              />
              <Typography variant="p" component="p" noWrap sx={{ color: isActiveRoute("/all_orders") ? theme.palette.common.white : theme.palette.common.grey}}>
                {t('allOrders')}
              </Typography>
            </MenuItem>
{/* Account */}
            <MenuItem 
              onClick={popupState.close} 
              component={RouterLink} 
              to="/account"
              sx={{
                ...menuItemStyle,
                backgroundColor: isActiveRoute("/account") ? theme.palette.primary.main : theme.palette.common.white,
                "&:hover": {
                  ".MuiTypography-root": {
                    color: isActiveRoute("/account") ? theme.palette.common.grey : theme.palette.primary.main
                  },
                  ".MuiSvgIcon-root": {
                    color: isActiveRoute("/account") ? theme.palette.common.grey : theme.palette.primary.main
                  }
                },
              }}
            >
              <SettingsOutlined
                sx={{
                  paddingRight: "20px",
                  color: isActiveRoute("/account") ? theme.palette.common.white : theme.palette.common.grey,
                  fontSize: "40px"
                }}
              />
              <Typography variant="p" component="p" noWrap sx={{ color: isActiveRoute("/account") ? theme.palette.common.white : theme.palette.common.grey}}>
                {t('accountSettings')}
              </Typography>
            </MenuItem>
{/* Sing Out */}
            <MenuItem onClick={handleLogOut} component={RouterLink} sx={{...menuItemStyle, "&:hover": {
                ".MuiTypography-root": {
                  color: isActiveRoute("/account") ? theme.palette.common.grey : theme.palette.primary.main
                },
                ".MuiSvgIcon-root": {
                  color: isActiveRoute("/account") ? theme.palette.common.grey : theme.palette.primary.main
                }
              }}}>
              <Logout sx={{ paddingRight: "20px", color: theme.palette.common.grey, fontSize: "40px" }} />
              <Typography variant="p" component="p" noWrap>
                {t('logOut')}
              </Typography>
            </MenuItem>

          </Menu>
        </>
      )}
    </PopupState>
  ) : null;
}